<template>
  <div>
    <div v-if="type == '产品铭牌'">
        <mp :info="info"></mp>
    </div>
    <div v-else>
        <zs :info="info"></zs>
    </div>
  </div>
</template>

<script>
import mp from './man8/mp.vue'
import zs from './man8/zs.vue'
export default {
    props:['id','type','info'],
    components:{
        mp,zs
    },

}
</script>




// WEBPACK FOOTER //
// src/components/manufacturers8.vue